type ValidationRule = {
  value: RegExp;
  message: string;
};

/**
 * Texto genérico
 * Letras (incluye acentos), números, espacios y símbolos comunes
 */
const text: ValidationRule = {
  value: /^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s.,/-]+$/,
  message: 'Solo se permiten letras, números y caracteres básicos.',
};

/**
 * Nombre / Apellido / Razón social
 */
const name: ValidationRule = {
  value: /^[A-Za-zñÑáéíóúÁÉÍÓÚ]+(?:\s+[A-Za-zñÑáéíóúÁÉÍÓÚ]+)*$/,
  message: 'Solo se permiten letras y espacios.',
};

/**
 * Email (RFC 5322 simplificado)
 */
const email: ValidationRule = {
  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  message: 'Ingrese un correo electrónico válido.',
};

/** Contraseña
 * Mínimo 8 caracteres, al menos una letra y un número
 */
const password: ValidationRule = {
  value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&._-]{8,}$/,
  message: 'Debe tener al menos 8 caracteres e incluir letras y números.',
};

/** DNI (8 dígitos)
 */
const dni: ValidationRule = {
  value: /^\d{8}$/,
  message: 'Ingrese un DNI válido de 8 dígitos.',
};

/**
 * Teléfono (máximo 10 dígitos numéricos)
 */
const phone: ValidationRule = {
  value: /^\d{1,10}$/,
  message: 'Ingrese un número de teléfono válido (máximo 10 dígitos).',
};

/**
 * Solo números
 */
const number: ValidationRule = {
  value: /^\d+$/,
  message: 'Solo se permiten números.',
};

/**
 * Monto de dinero
 * 1000 | 1.000 | 1.000,50
 */
const money: ValidationRule = {
  value: /^\d{1,3}(\.\d{3})*(,\d{1,2})?$/,
  message: 'Ingrese un monto válido.',
};

/**
 * Monto decimal
 * 0 | 123 | 123.45 | 123,45
 * Acepta punto o coma como separador decimal
 */
const monto: ValidationRule = {
  value: /^\d+([.,]\d{1,2})?$/,
  message: 'Solo se permiten números y hasta 2 decimales.',
};

/**
 * Concepto de comprobante
 * Letras, números, espacios y caracteres básicos
 */
const concepto: ValidationRule = {
  value: /^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s.,/-]+$/,
  message: 'Solo se permiten letras, números, espacios y caracteres básicos.',
};

/**
 * Validación para archivo requerido
 */
const comprobante = (value: any): true | string => {
  if (!value) return 'El comprobante es requerido.';
  return true;
};

/**
 * Validación de fecha de nacimiento de mascotas
 * - Debe tener al menos 3 meses de edad
 * - No puede tener más de 18 años
 */
const validatePetBirthDate = (value: string): true | string => {
  if (!value) return true;

  const birthDate = new Date(value);
  const today = new Date();

  // Calcular edad en meses
  let months = (today.getFullYear() - birthDate.getFullYear()) * 12;
  months += today.getMonth() - birthDate.getMonth();

  // Calcular edad en años
  const years = Math.floor(months / 12);

  // Validar que tenga al menos 3 meses
  if (months < 3) {
    return 'La mascota debe tener al menos 3 meses de edad';
  }

  // Validar que no tenga más de 18 años
  if (years > 18) {
    return 'La mascota no puede tener más de 18 años';
  }

  return true;
};

export type { ValidationRule };

export const validations = {
  text,
  name,
  email,
  password,
  dni,
  phone,
  number,
  money,
  monto,
  concepto,
  comprobante,
  validatePetBirthDate,
};
